<div fxLayout="column" fxLayoutGap="10px">
	<h1 mat-dialog-title>Upload Document</h1>
	<rpshared-add-document [formControl]="control"></rpshared-add-document>
	<div mat-dialog-actions>
		<button mat-button mat-dialog-close color="warn">
			Cancel
		</button>
		<button
			mat-button
			[disabled]="group.invalid"
			color="primary"
			[mat-dialog-close]="group"
		>
			Save
		</button>
	</div>
</div>
